<template>
<div class="card-panel-container">
  <!-- 顶部标题栏 -->
  <div class="top-container">
    <div class="title-text">
      <div class="do-time">{{ $str.getKey('收益管理/抄表时间：') }}{{ fmtd(data.date) }}</div>
      <div class="tip-info" v-if="data.type == 3">{{ $str.getKey('收益管理/（当天使用自定义电价，该项数据仅供参考）') }}</div>
    </div>
  </div>
  <!-- 信息面板 -->
  <div class="info-container">
    <div class="info-row info-row0">
      <div class="cell col0-cell">{{ $str.getKey('收益管理/时间段') }}</div>
      <div class="cell col0-cell">
        <div class="ring-symbol" :style="{color: priceColor.sharp}"></div>
        <span>{{ $str.getKey('收益管理/尖峰时段') }}</span>
      </div>
       <!-- <div class="cell col0-cell">
        <div class="ring-symbol" :style="{color: priceColor.highPeak}"></div>
        <span>{{ $str.getKey('收益管理/高峰时段') }}</span>
      </div> -->
      <div class="cell col0-cell">
        <div class="ring-symbol" :style="{color: priceColor.peak}"></div>
        <span>{{ $str.getKey('收益管理/高峰时段') }}</span>
      </div>
      <div class="cell col0-cell">
        <div class="ring-symbol" :style="{color: priceColor.flat}"></div>
        <span>{{ $str.getKey('收益管理/平时段') }}</span>
      </div>
      <div class="cell col0-cell">
        <div class="ring-symbol" :style="{color: priceColor.valley}"></div>
        <span>{{ $str.getKey('收益管理/低谷时段') }}</span>
      </div>
       <div class="cell col0-cell">
        <div class="ring-symbol" :style="{color: priceColor.deepValley}"></div>
        <span>{{ $str.getKey('收益管理/深谷时段') }}</span>
      </div>
      <div class="cell col0-cell">{{ $str.getKey('收益管理/总') }}</div>
    </div>
    <div class="info-row info-row1">
      <div class="cell col1-cell-title">{{ $str.getKey('收益管理/正向有功') }}</div>
      <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.ePositiveSharp) }}</span>
        <span class="unit-text">kWh</span>
      </div>
       <!-- <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.ePositiveHigherPeak) }}</span>
        <span class="unit-text">kWh</span>
      </div> -->
      <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.ePositivePeak) }}</span>
        <span class="unit-text">kWh</span>
      </div>
      <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.ePositiveFlat) }}</span>
        <span class="unit-text">kWh</span>
      </div>
      <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.ePositiveValley) }}</span>
        <span class="unit-text">kWh</span>
      </div>
        <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.ePositiveDeepValley) }}</span>
        <span class="unit-text">kWh</span>
      </div>
      <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.ePositive) }}</span>
        <span class="unit-text">kWh</span>
      </div>
      
    </div>
    <div class="info-row info-row2">
      <div class="cell col2-cell-title">{{ $str.getKey('收益管理/反向有功') }}</div>
      <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.eReverseSharp) }}</span>
        <span class="unit-text">kWh</span>
      </div>
         <!-- <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.eReverseHigherPeak) }}</span>
        <span class="unit-text">kWh</span>
      </div> -->
      <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.eReversePeak) }}</span>
        <span class="unit-text">kWh</span>
      </div>
      <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.eReverseFlat) }}</span>
        <span class="unit-text">kWh</span>
      </div>
         <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.eReverseValley) }}</span>
        <span class="unit-text">kWh</span>
      </div>
      <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.eReverseDeepValley) }}</span>
        <span class="unit-text">kWh</span>
      </div>
      <div class="cell col1-cell">
        <span class="value-text">{{ formatValue(data.eReverse) }}</span>
        <span class="unit-text">kWh</span>
      </div>
    </div>
  </div>
</div>

</template>

<script setup>
import { ref, defineProps, defineEmits } from "vue";
import dayjs from 'dayjs'
import { getElecPriceSegmentColor } from '@/utils/colorHelper/index.js'

const $str = window.$str;
const priceColor = getElecPriceSegmentColor();

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  size: {
    type: String,
    default: 'large',
    validator(value) {
      return ['small', 'large'].includes(value)
    }
  },
})

function fmtd(date) {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
}

function formatValue(value) {
  if (isNaN(value)) {
    return '- -';
  } else {
    return Number(value).toFixed(1);
  }
}

</script>
<style lang='scss' scoped>
.card-panel-container {
  margin: 0 8px;
  margin-top: 8px;
  width: auto;
  min-width: 0;
  max-width: 100%;
  height: 186px;
  background: rgba(255, 255, 255, 0.40);
  border: 1px solid #EDF2F6;
  border-radius: 6px 6px 6px 6px;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  overflow: hidden;
  box-sizing: border-box;
  
  .top-container {
    flex-shrink: 0;
    width: 100%;
    height: 68px;
    background: linear-gradient(109deg, rgba(231, 237, 255, 0.40) 1.53%, rgba(255, 255, 255, 0.40) 98.28%);
    border-bottom: 1px solid #FFF;
    border-radius: 6px 6px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;

    .title-text {
      padding: 0;
      color: #2E2E2E;
      font-family: "HarmonyOS Sans SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      display: flex;
      gap: 20px;
      align-items: center;

      .do-time {
        color: #2E2E2E;
        font-family: "HarmonyOS Sans SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
      .tip-info {
        color: #2E2E2E;
        font-family: "HarmonyOS Sans SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }

  .info-container {
    flex: 0 0 118px;
    display: flex;
    flex-direction: column;
    padding: 10px 20px 0 20px;
    box-sizing: border-box;
    color: #2E2E2E;
    font-family: "HarmonyOS Sans SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    justify-content: flex-start;
    align-items: stretch;
    height: 118px;
    min-height: 118px;
    max-height: 118px;
    overflow: hidden;
    gap: 0;
    margin: 0;
    padding-bottom: 0;
    align-content: flex-start;

    .info-row {
      flex: 0 0 36px;
      height: 36px;
      min-height: 36px;
      max-height: 36px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0;
      padding: 0;
      color: #2E2E2E;
      font-family: "HarmonyOS Sans SC";
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px;
      text-align: left;
      box-sizing: border-box;
      overflow: hidden;
      
      &:last-child {
        margin-bottom: 0;
        padding-bottom: 0;
      }

      .cell {
        width: 100px;
        margin: 0 10px;
        padding: 0;
        line-height: 36px;
        color: #2E2E2E;
        font-family: "HarmonyOS Sans SC";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        vertical-align: top;

        &.col0-cell {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        &.col1-cell {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        &.col1-cell-title,
        &.col2-cell-title {
          color: #2E2E2E;
          font-family: "HarmonyOS Sans SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 36px;
          height: 36px;
          display: flex;
          align-items: center;
        }
        .ring-symbol {
          width: 14px !important;
          height: 14px;
          border: 3px solid currentColor;
          border-radius: 50%;
          margin: 4px;
        }
        .value-text {
          color: #2E2E2E;
          font-family: "HarmonyOS Sans SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          text-align: left;
        }
      }
      
      // 正向有功和反向有功的数据加粗
      &.info-row1 .value-text,
      &.info-row2 .value-text {
        font-weight: 700;
        .unit-text {
          margin-left: 6px;
          color: #2E2E2E;
          font-family: "HarmonyOS Sans SC";
          font-size: 12px;
          font-style: normal;
          font-weight: 300;
          line-height: normal;
        }
      }

    }


    
  }
}
</style>
